import React, { useState } from "react"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useNavigate } from "react-router-dom"
import { MainContainer } from "../../components"
import { Card, CardBody, CardFooter, Button, Input } from "@nextui-org/react"
import { usePost } from "../../api/reactQueryCustomHooks"

function CreateAppMaster() {
  const navigate = useNavigate()
  const [errors, setErrors] = useState({})

  const [formData, setFormData] = useState({
    appName: "",
  })
  const onClickPrevPage = () => {
    navigate(linksUrl.appMaster.read)
  }

  const onSuccessTasks = () => {
    navigate(linksUrl.appMaster.read)
  }
  const resetValues = () => {}

  const { isPending, mutate: addAppMaster } = usePost({
    url: apiRoute.appMaster.add,
    queryKey: "AppMaster",
    resetValues,
    successMessage: "",
    onSuccessTasks,
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const validateForm = () => {
    const newErrors = {}

    // Validate AppName
    if (formData.appName.trim() === "") {
      newErrors.appName = "App Name is required"
    }

    setErrors(newErrors)

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (validateForm()) {
      // Perform form submission logic here
      addAppMaster({
        data: {
          appName: formData.appName,
        },
      })
    }
  }

  return (
    <MainContainer
      breadcrumbs={["App Master", "add"]}
      pageName={"Add App"}
      prevPage={{ show: true, onClick: onClickPrevPage }}
    >
      <Card className="max-w-[600px]" shadow="none" classNames="p-0">
        <form onSubmit={handleSubmit}>
          <CardBody className="p-0">
            <div className="flex flex-col gap-4 mx-2">
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">
                <Input
                  type="text"
                  label="App Name"
                  placeholder=" "
                  labelPlacement="outside"
                  isInvalid={errors?.appName}
                  errorMessage={errors?.appName}
                  name="appName"
                  value={formData.appName}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
              </div>
            </div>
          </CardBody>
          <CardFooter>
            <Button color="primary" type="submit" isLoading={isPending}>
              Add App
            </Button>
          </CardFooter>
        </form>
      </Card>
    </MainContainer>
  )
}

export default CreateAppMaster
